import React from 'react';
import { useFormik } from 'formik';
import '@/styles/main.scss';
import { FormProps, NUMBER_OF_PARTNER_FORM_PAGES } from '@/data/Types';
import FormContent from '@/components/FormContent';
import Personvern from '@/components/Personvern';
import { personalInfoInitialValues, personalInfoValidationSchema } from '@/forms/fields/personalInfo';

const validationSchema = personalInfoValidationSchema();
const initialValues = personalInfoInitialValues();

const PartnerForm = ({ onSubmit, setPage, page, sentError, removeSentError }: FormProps) => {
    const formik = useFormik({ onSubmit, validationSchema, initialValues });

    return (
        <div className="frame-content">
            <div className="container">
                <form className="form-container" onSubmit={formik.handleSubmit}>
                    <FormContent
                        pages={NUMBER_OF_PARTNER_FORM_PAGES}
                        page={page}
                        setPage={setPage}
                        formik={formik}
                        sentError={sentError}
                        removeSentError={removeSentError}
                        withOptionalComment
                    />
                </form>
                <Personvern />
            </div>
        </div>
    );
};

export default PartnerForm;
